"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var baseUrl = '/svc/fleet-pricing';
exports.CONTRACTS_ENDPOINT = {
    postContract: baseUrl + "/contracts",
    postContractFile: baseUrl + "/contracts/{{contractUuid}}/contract-document",
};
exports.SALES_ORDERS_ENDPOINT = {
    getSalesOrder: baseUrl + "/contracts/{{contractUuid}}/sales-orders/{{salesOrderUuid}}",
    postSalesOrderExistingVehicles: baseUrl + "/contracts/{{contractUuid}}/sales-orders",
    postSalesOrderNewVehicles: baseUrl + "/contracts/{{contractUuid}}/sales-orders-unregistered",
};
exports.SERVICE_FEES_ENDPOINT = {
    postForContract: baseUrl + "/contracts/{{contractUuid}}/service-fees",
    postForSalesOrder: baseUrl + "/contracts/{{contractUuid}}/sales-orders/{{salesOrderUuid}}/service-fees",
    putForContract: baseUrl + "/contracts/{{contractUuid}}/service-fees/{{serviceFeeUuid}}",
    putSalesOrderServiceFee: baseUrl + "/contracts/{{contractUuid}}/sales-orders/{{salesOrderUuid}}/service-fees/{{serviceFeeUuid}}",
};
exports.INVOICE_PLANS_ENDPOINT = {
    postInvoicePlan: baseUrl + "/invoice-plans",
    putInvoicePlan: baseUrl + "/invoice-plans/{{invoicePlanUuid}}",
};
